// La page d'une Page est passée à React (js/react/ecrans/Page.jsx).
//
// La fenêtre « Gérer la page » a été sortie dans `page-gerer.js` : comme les
// autres fenêtres modales, elle reste en HTML.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Page from "../react/ecrans/Page.jsx";

export const rendre = vueReact(Page);
